// The Motion brand mark, expressed as a real SVG of paths (not <text>, not a
// raster) so it can be animated by every template — stroke_reveal needs open
// paths, kinetic_typography needs multiple targets, etc.
//
// Geometry
// --------
// - Outer triangle (the "M" silhouette).
// - Inner horizontal bar (the crossbar).
// - Three thin tick marks underneath, used as letters for kinetic_typography
//   demos. They render below the bar so they read as "motion meter".

export const MOTION_MARK_SVG = `<svg viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="white" stroke-width="9" stroke-linecap="round" stroke-linejoin="round">
  <path d="M40 188 L120 50 L200 188 Z" />
  <path d="M76 140 L164 140" />
  <path d="M64 208 L88 208" />
  <path d="M108 208 L132 208" />
  <path d="M152 208 L176 208" />
</svg>`;
